import {KatLink} from "@amzn/katal-react";
import * as React from "react";

const Footer = () => {
    return ( <footer slot="bottom" className='inline-display text-center foot'>
        <KatLink label={'Site Terms'} variant={'link'} className={'foot-kat-link'} data-testid="site-term-link">Site Terms</KatLink>
        <KatLink label={'Privacy Notice'} variant={'link'} className={'foot-kat-link'} data-testid="privacy-notice-link">Privacy Notice</KatLink>
        © 2024 Amazon.com, Inc. or its affiliates. All Rights Reserved
    </footer>);
}

export default Footer;